// @flow
import PlainLinkAsButton, { type PlainLinkAsButtonProps } from './plain-link-as-button';

export default PlainLinkAsButton;
export type { PlainLinkAsButtonProps };
